import { useState } from 'react';

export default function Services() {
  const [showBookingModal, setShowBookingModal] = useState(false);
  const [selectedService, setSelectedService] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'success' | 'error' | null>(null);

  const services = [
    {
      id: 1,
      name: 'Thai Massage',
      price: '170 AED',
      description: 'Traditional Thai massage to relieve stress and relax body & mind',
      duration: '1 Hour',
      bgColor: 'bg-blue-50',
      buttonStyle: 'bg-gray-900 text-white hover:bg-gray-800',
      image: 'https://public.readdy.ai/ai/img_res/e0e80c5d017627773c2a9b161295c56c.jpg'
    },
    {
      id: 2,
      name: 'Moroccan Bath Massage',
      price: '250 AED',
      description: 'Traditional Moroccan bath therapy for deep cleansing and skin rejuvenation',
      duration: '1 Hour',
      bgColor: 'bg-gray-50',
      buttonStyle: 'bg-white text-gray-900 border border-gray-900 hover:bg-gray-50',
      image: 'https://readdy.ai/api/search-image?query=Luxurious%20Moroccan%20bath%20spa%20setting%20with%20traditional%20hammam%20elements%2C%20ornate%20brass%20bowls%20filled%20with%20natural%20black%20soap%20and%20argan%20oil.%20Warm%20steam%20atmosphere%20with%20mosaic%20tile%20details%20and%20soft%20golden%20lighting.%20Clean%20simple%20background%20in%20warm%20beige%20and%20cream%20tones.%20Professional%20spa%20photography%20showcasing%20authentic%20Moroccan%20bath%20ritual%20with%20elegant%20minimalist%20composition%20and%20traditional%20wellness%20elements.&width=400&height=300&seq=service-moroccan-bath-003&orientation=landscape'
    },
    {
      id: 3,
      name: 'Jacuzzi Bath Massage',
      price: '300 AED',
      description: 'Hydrotherapy massage combination for ultimate relaxation experience',
      duration: '1 Hour',
      bgColor: 'bg-gray-50',
      buttonStyle: 'bg-white text-gray-900 border border-gray-900 hover:bg-gray-50',
      image: 'https://readdy.ai/api/search-image?query=Elegant%20modern%20jacuzzi%20spa%20bath%20with%20bubbling%20water%20jets%20in%20luxurious%20wellness%20center.%20Soft%20ambient%20lighting%20with%20candles%20and%20natural%20stone%20elements.%20Clean%20minimalist%20spa%20interior%20with%20warm%20beige%20and%20cream%20colored%20background.%20Professional%20spa%20photography%20showcasing%20premium%20hydrotherapy%20experience%20with%20serene%20peaceful%20atmosphere%20and%20sophisticated%20simple%20composition.&width=400&height=300&seq=service-jacuzzi-bath-004&orientation=landscape'
    }
  ];

  const handleBookNow = (serviceName: string) => {
    setSelectedService(serviceName);
    setShowBookingModal(true);
    setSubmitStatus(null);
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    const form = e.currentTarget;
    const formData = new FormData(form);

    try {
      const response = await fetch('https://readdy.ai/api/form/d59v484f78kfudd4ju70', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(formData as any).toString(),
      });

      if (response.ok) {
        setSubmitStatus('success');
        form.reset();
        setTimeout(() => {
          setShowBookingModal(false);
          setSubmitStatus(null);
        }, 2000);
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <section id="services" className="py-24 bg-amber-50/30">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-5xl md:text-6xl font-light text-gray-900 mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
              Our Services
            </h2>
            <p className="text-base text-gray-600">Customized healing solutions for you</p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {services.map((service) => (
              <div key={service.id} className="bg-white rounded-3xl overflow-hidden shadow-sm hover:shadow-lg transition-shadow">
                <div className={`${service.bgColor} h-64 rounded-3xl m-4 bg-cover bg-center`} style={{ backgroundImage: `url(${service.image})` }}></div>

                <div className="p-6 text-center">
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">{service.name}</h3>
                  <div className="text-3xl font-light text-amber-900 mb-3">{service.price}</div>
                  <p className="text-sm text-gray-600 mb-6">{service.description}</p>

                  <button 
                    onClick={() => handleBookNow(service.name)}
                    className={`w-4/5 mx-auto block py-3 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${service.buttonStyle}`}
                  >
                    Book Now
                  </button>

                  <p className="text-xs text-gray-400 mt-4">{service.duration}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {showBookingModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4" onClick={() => setShowBookingModal(false)}>
          <div className="bg-white rounded-2xl max-w-md w-full p-8 relative" onClick={(e) => e.stopPropagation()}>
            <button
              onClick={() => setShowBookingModal(false)}
              className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 cursor-pointer"
            >
              <i className="ri-close-line text-2xl"></i>
            </button>

            <h3 className="text-2xl font-semibold text-gray-900 mb-2">Book Your Appointment</h3>
            <p className="text-sm text-gray-600 mb-6">Selected Service: <span className="font-medium text-amber-900">{selectedService}</span></p>

            <form id="spa-booking-form" data-readdy-form onSubmit={handleSubmit}>
              <input type="hidden" name="service" value={selectedService} />

              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-2">Full Name *</label>
                <input
                  type="text"
                  name="name"
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-900 focus:border-transparent text-sm"
                  placeholder="Enter your full name"
                />
              </div>

              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-2">Email *</label>
                <input
                  type="email"
                  name="email"
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-900 focus:border-transparent text-sm"
                  placeholder="your@email.com"
                />
              </div>

              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-2">Phone Number *</label>
                <input
                  type="tel"
                  name="phone"
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-900 focus:border-transparent text-sm"
                  placeholder="+971 XX XXX XXXX"
                />
              </div>

              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-2">Preferred Date *</label>
                <input
                  type="date"
                  name="date"
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-900 focus:border-transparent text-sm"
                />
              </div>

              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-2">Preferred Time *</label>
                <select
                  name="time"
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-900 focus:border-transparent text-sm"
                >
                  <option value="">Select a time</option>
                  <option value="09:00 AM">09:00 AM</option>
                  <option value="10:00 AM">10:00 AM</option>
                  <option value="11:00 AM">11:00 AM</option>
                  <option value="12:00 PM">12:00 PM</option>
                  <option value="01:00 PM">01:00 PM</option>
                  <option value="02:00 PM">02:00 PM</option>
                  <option value="03:00 PM">03:00 PM</option>
                  <option value="04:00 PM">04:00 PM</option>
                  <option value="05:00 PM">05:00 PM</option>
                  <option value="06:00 PM">06:00 PM</option>
                  <option value="07:00 PM">07:00 PM</option>
                  <option value="08:00 PM">08:00 PM</option>
                </select>
              </div>

              <div className="mb-6">
                <label className="block text-sm font-medium text-gray-700 mb-2">Special Requests</label>
                <textarea
                  name="message"
                  rows={3}
                  maxLength={500}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-900 focus:border-transparent text-sm resize-none"
                  placeholder="Any special requests or preferences? (Max 500 characters)"
                ></textarea>
              </div>

              {submitStatus === 'success' && (
                <div className="mb-4 p-3 bg-green-50 border border-green-200 rounded-lg text-green-700 text-sm">
                  ✓ Booking submitted successfully! We'll contact you soon.
                </div>
              )}

              {submitStatus === 'error' && (
                <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg text-red-700 text-sm">
                  ✗ Something went wrong. Please try again.
                </div>
              )}

              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full py-3 bg-amber-900 text-white rounded-full font-medium hover:bg-amber-800 transition-all whitespace-nowrap cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {isSubmitting ? 'Submitting...' : 'Confirm Booking'}
              </button>
            </form>
          </div>
        </div>
      )}
    </>
  );
}
